// components/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

// Define the PrivateRoute component
// It takes two props:
// - isAuthenticated: true/false once the server has answered, null while still checking
// - children: the component(s) to render if the user *is* authenticated
// This only controls what the browser shows; the API itself enforces [Authorize].
const PrivateRoute = ({ isAuthenticated, children }) => {
    if (isAuthenticated === null) return <p>Checking login...</p>;

    // If the user is authenticated, render the children (protected content)
    // If not, redirect them to the LoginPage
    return isAuthenticated ? children : <Navigate to="/LoginPage" />;
};

export default PrivateRoute;
